import '../vendor'
import { reactive, or, VArray, Variable } from 'alkali'
import Authentication from './authentication'
import { post } from 'tools/request'
import { startHotjar } from 'components/tracking/track'

export const app = window.app = {
	authdUser: reactive({}),
	authentication: new Authentication({}),
	clientId: String(Math.random()).slice(2),
	isSuperAdmin() {
		return !!this.user?.Roles?.find(r => r.Name == 'dre_super_admin')
	},
	impersonate(userId) {
		return post('/portal/user/' + app.user.userId, {
			method: 'impersonate',
			userId,
		}).then(() => location.reload())
	},

	impersonateEnd() {
		return post('/portal/user/' + app.user.userId, {
			method: 'impersonateEnd',
		}).then(() =>
			location.reload())
	},
  	logout() {
	  	this.authdUser.put(this.user = null)
	}
}
app.authentication.session = window.userRequest
app.user = window.userRequest.then(user =>
	app.user = user, () => app.user = null)
export const userSettings = reactive(app.user).to(user => user.Settings)

app.authdUser.put(app.user)
app.authentication.getSession()
app.userVar = app.authdUser 

export default app

app.user.then(user => {
	if (user?.FeatureConfig?.Hotjar?.Enabled)
		startHotjar()
})